export default "__VITE_ASSET__BIpGbLrX__"